module.exports = __webpack_public_path__ + "media/images/example_shirt-765857bd2da47c19ce77c1063085d3b0.png";